module.exports = __webpack_public_path__ + "img/wz-1-2.c0d4a203.png";